// Applies the saved theme before React renders to avoid a flash of the wrong theme.
try {
  const saved = localStorage.getItem('cartly.theme');
  if (saved === 'light' || saved === 'dark' || saved === 'system') {
    document.documentElement.dataset['theme'] = saved;
  }
} catch {
  // Storage unavailable (private mode): keep the default "system".
}
